import styled, { css } from 'styled-components'
import AppButton from 'Components/AppButton'
import { OUTLINE_COLOR, SELECTED_ITEM_BG_COLOR, LIKE_BTN_COLOR, FORM_BG_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'

const iconBoxMixin = css`
  margin-top: 8px;
  padding: 0 10px;
  height: 44px;
  border:  1px solid ${OUTLINE_COLOR};
  border-radius: 10px;
  span {
    margin-left: 5px;
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }

`

export const _PreconFloorPlanContainer = styled.div`
  ${({ listings }) => (listings ? '' : 'padding-bottom: 25px;')};
  padding-bottom: 1px;
  .preconShowMore {
    margin-top: 24px;
    padding-left: 0;
    z-index: 100;
  }
`

export const _TopBar = styled.div`
  margin: 24px 0;
  display: flex;
  gap: 12px;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    flex-direction: column;
    gap: 24px;
  }
`

export const _NoListings = styled.div`
  background-color: ${FORM_BG_COLOR};
  padding: 20px 24px;
  margin-bottom: 44px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  div {
    line-height: 22px;
  }
  div:first-child {
    font-size: 14px;
    font-weight: 600;
  }

  div:not(:first-child)  {
    margin-top: 8px;
  }
`

export const _LastUpdated = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  span {
    margin-right: 8px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`

export const _FavCTA = styled(AppButton)`
  ${iconBoxMixin};
  .favouriteSt2 {
    fill: ${LIKE_BTN_COLOR} !important;
    stroke: none !important;
  }
  .st6 {
    stroke: none;
  }
  span {
    color: ${LIKE_BTN_COLOR} !important;
  }
  ${({ active }) =>
    (active
      ? `
          .st6 {
            fill: ${LIKE_BTN_COLOR} !important;
          }
        `
      : `
          .st6 {
            fill: white !important;
          }
        `)}
  &:active {
    background-color: ${SELECTED_ITEM_BG_COLOR} !important;
  }
`

export const _FilterSortBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    gap: 8px;
  }
`

export const _TabContainer = styled.div`
  max-width: 260px;
  width: auto;
`
